import { Injectable } from '@angular/core'
import { MbCheckoutQuoteInfoAdapter } from './mb-checkout-quote-info.adapter'
import { MbQuoteInfoModel } from '../../../models'

@Injectable({
  providedIn: 'root',
})
export class MbCheckoutQuoteInfoConnector {

  constructor (protected adapter: MbCheckoutQuoteInfoAdapter) {
  }

  post (quoteInfoDetails: MbQuoteInfoModel, cartID: string) {
    return this.adapter.post(quoteInfoDetails, cartID)
  }
}
